import { render, staticRenderFns } from "./purchase-planning.vue?vue&type=template&id=5334c031"
import script from "./purchase-planning.vue?vue&type=script&lang=js"
export * from "./purchase-planning.vue?vue&type=script&lang=js"
import style0 from "./purchase-planning.vue?vue&type=style&index=0&id=5334c031&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports